import { FileText } from "lucide-react";

import { PresentationLink } from "./PresentationLink";

import { cn } from "@/common/lib";

export function UserGuideLink({ classNameBtn }: { classNameBtn?: string }) {
  return (
    <PresentationLink
      href="/user-guide.pdf"
      classNameBtn={cn(
        "border-primary bg-transparent text-orange-700 hover:bg-orange-50 hover:text-orange-800",
        classNameBtn,
      )}
    >
      <FileText aria-hidden="true" />
      Инструкция пользователя
    </PresentationLink>
  );
}
